import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const wishlistItem = {
    bra: {
        brand: null,
        name: null,
        color: '#000000',
        size: {
            band: null,
            cup: null,
        },
    },
    description: null,
    mutableId: null,
    charity: null,
    url: null,
    media: {
        url: [],
    },
    size: null,
    msrp: null,
}
const store = new Vuex.Store({
    state: {
        wishlistDataCounts: null,
        wishlistData: null,
        forcedUpdate: null,
        wishlistItem,
        errorCode: null,
        errorMessage: null,
        creationState: null,
        isAuthenticated: null,
        users: {
            data: [],
            timestamp: Date.now(),
        },
        deferredPrompt: null,
        showInstallPromotion: null,
        account: {
            wishlist: {
                index: 0,
                expansionPanelIndex: null,
            },
            expansionPanelIndex: null,
            nfts: {
                expansionPanels: [],
            },
        },
        tour: {
            currentStep: undefined,
        },
        form: {
            createNft: {
                price: {
                    NEAR: null,
                    USD: null,
                },
                bra: {
                    brand: null,
                    name: null,
                    color: '#000000',
                    size: null,
                },
                description: null,
            },
            createWishlist: {
                name: null,
                description: null,
                mutableId: null,
                chartiy: null,
                media: {
                    url: null,
                },
                activeItemId: 'default',
                items: {
                    default: wishlistItem,
                }
            },
            assets: {
                tag: {
                    url: null,
                },
                bra: {
                    url: null,
                },
                left: {
                    url: null,
                },
                front: {
                    url: null,
                },
                right: {
                    url: null,
                },
                back: {
                    url: null,
                },
                nude: {
                    url: null,
                },
                fitting: {
                    url: null,
                },
                secret: {
                    url: null,
                },
            },
        },
        step: 1,
        currentJob: {
            id: null,
        },
        hooks: {
            callMintContract: null,
        },
        resetFormOnReloadTrigger: null,
        commissionUsername: null,
        commissionNetwork: null,
        lastNearListing: null,
        commissionState: null,
        usedUnsplash: {},
    },
    mutations: {
        clearError(state) {
            Vue.set(state, 'errorCode', null);
            Vue.set(state, 'errorMessage', null);
        },
        set(state, payload) {
            delete payload.type;
            const kvPairs = Object.entries(payload);
            kvPairs.forEach((kv) => {
                Vue.set(state, kv[0], kv[1]);
            });
        },
        delete(state, keys) {
            keys.forEach((key) => {
                Vue.delete(state, key);
            });
        },
        update(state, payload) {
            delete payload.type;
            const kvPairs = Object.entries(payload);
            kvPairs.forEach((kv) => {
                const key = kv[0],
                    value = kv[1];
                const valueIndex = parseInt(Object.keys(value)[0]);
                if (typeof value === 'object' && !isNaN(valueIndex)) {
                    const oldObject = state[`${key}`];
                    oldObject[valueIndex] = Object.values(value)[0];
                    Vue.set(state, key, oldObject);
                }
            });
        },
        step(state, value) {
            Vue.set(state, 'step', value);
        },
        updateAssets(state, value) {
            Vue.set(state.form, 'assets', value);
        },
        updateWishlistAssets(state, value) {
            if (value.wishlist) Vue.set(state.form.createWishlist, 'media', value.wishlist);
            if (value.bras) Vue.set(state.form.createWishlist.items[state.form.createWishlist.activeItemId], 'media', value.bras);
        },
        updateBraBrand(state, value) {
            Vue.set(state.form.createNft.bra, 'brand', value);
        },
        updateBraName(state, value) {
            Vue.set(state.form.createNft.bra, 'name', value);
        },
        updateBraColor(state, value) {
            Vue.set(state.form.createNft.bra, 'color', value);
        },
        updateBraSize(state, value) {
            Vue.set(state.form.createNft.bra, 'size', value);
        },
        updateDescription(state, value) {
            Vue.set(state.form.createNft, 'description', value);
        },
        updatePrice(state, value) {
            Vue.set(state.form.createNft, 'price', value);
        },
        updateWishlistName(state, value) {
            Vue.set(state.form.createWishlist, 'name', value);
        },
        updateWishlistDescription(state, value) {
            Vue.set(state.form.createWishlist, 'description', value);
        },
        updateWishlistMutableId(state, value) {
            Vue.set(state.form.createWishlist, 'mutableId', value);
        },
        updateWishlistCharity(state, value) {
            Vue.set(state.form.createWishlist, 'charity', value);
        },
        updateItemDescription(state, value) {
            Vue.set(state.form.createWishlist.items[state.form.createWishlist.activeItemId], 'description', value);
        },
        updateItemMSRP(state, value) {
            Vue.set(state.form.createWishlist.items[state.form.createWishlist.activeItemId], 'msrp', value);
        },
        updateItemBrand(state, value) {
            Vue.set(state.form.createWishlist.items[state.form.createWishlist.activeItemId].bra, 'brand', value);
        },
        updateItemName(state, value) {
            Vue.set(state.form.createWishlist.items[state.form.createWishlist.activeItemId].bra, 'name', value);
        },
        updateItemSize(state, value) {
            Vue.set(state.form.createWishlist.items[state.form.createWishlist.activeItemId], 'size', value);
        },
        updateItemBandSize(state, value) {
            Vue.set(state.form.createWishlist.items[state.form.createWishlist.activeItemId].bra.size, 'band', value);
        },
        updateItemCupSize(state, value) {
            Vue.set(state.form.createWishlist.items[state.form.createWishlist.activeItemId].bra.size, 'cup', value);
        },
        updateItemUrl(state, value) {
            Vue.set(state.form.createWishlist.items[state.form.createWishlist.activeItemId], 'url', value);
        },
        updateActiveItemId(state, value) {
            Vue.set(state.form.createWishlist, 'activeItemId', value);
        },
        updateWishlistItems(state, value) {
            Vue.set(state.form.createWishlist, 'items', value)
        },
        updateWishlistIndex(state, value) {
            Vue.set(state.account.wishlist, 'index', value);
        },
        deleteWishlistItems(state, ids) {
            ids.forEach((id) => {
                Vue.delete(state.form.createWishlist.items, id)
            });
        },
        resetAsset(state, asset) {
            Vue.set(state.form.assets, asset, {
                url: null,
                type: null,
                thumb: null,
                serverId: null,
            });
        },
        resetWishlistAssets(state, asset) {
            if (asset === 'wishlist') {
                Vue.set(state.form.createWishlist, 'media', {});
            } else if (asset === 'bra') {
                for (item of items) Vue.set(item, 'media', {});
            }
        },
        resetFormOnReload(state, value) {
            Vue.set(state, 'resetFormOnReloadTrigger', value);
        },
        resetForm(state, form) {
            switch (form) {
                case 'createNft':
                    Vue.set(state.form, 'createNft', {
                        price: {
                            NEAR: null,
                            USD: null,
                        },
                        bra: {
                            brand: null,
                            name: null,
                            color: '#000000',
                            size: null,
                        },
                        description: null,
                    });
                    Vue.set(state.form, 'assets', {
                        tag: {
                            url: null,
                        },
                        bra: {
                            url: null,
                        },
                        left: {
                            url: null,
                        },
                        front: {
                            url: null,
                        },
                        right: {
                            url: null,
                        },
                        back: {
                            url: null,
                        },
                        nude: {
                            url: null,
                        },
                        fitting: {
                            url: null,
                        },
                        secret: {
                            url: null,
                        },
                    }); break;
                case 'createWishlist':
                    Vue.set(state.form, 'createWishlist', {
                        name: null,
                        description: null,
                        mutableId: null,
                        chartiy: null,
                        media: {
                            url: null,
                        },
                        activeItemId: 'default',
                        items: {
                            default: wishlistItem,
                        },
                    }); break;
            }
        },
        setHook(state, value) {
            Vue.set(
                state.hooks,
                Object.keys(value)[0],
                Object.values(value)[0]
            );
        },
        resetCreationState(state) {
            Vue.set(state, 'creationState', {});
        },
        resetCommissionState(state) {
            Vue.set(state, 'commissionState', {});
        },
    },
    plugins: [createPersistedState()],
});

Vue.prototype.$store = store;

export default store;
